import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=45b910dd&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=45b910dd&prod&scoped=true&lang=css"
import style1 from "./Attribute.vue?vue&type=style&index=1&id=45b910dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b910dd",
  null
  
)

export default component.exports